import { history } from '../../helpers';
import { userConstants } from '../../store/actionTypes';
import { alertActions } from './';
import { profileAPIs, userAPIs } from '../../api';
import CryptoJS from "crypto-js";
import { UserService } from '../../services/storage.service';

export const profileActions = {
    changePassword,
    fetchUserData,
    updateContactInfo,
    updateProfileImage,
    getUserTotalDonation,
    getUserDonationHistory,
    getLatestDonationsByUser,
    cancelSubscription,
    updateLoaderState,
    updateLoaderStatePassword,
    getUserActivities,
    getUserGraphData,
};

function changePassword(payload) {
    return async dispatch => {
        dispatch(request(payload));
        try {
            const response = await profileAPIs.changePassword(payload);
            dispatch(updateLoaderStatePassword(false));
            if (response.data.error) {
                dispatch(failure(response.data.error.toString()));
                dispatch(alertActions.error(response.data.error.toString()));
            }
            else if (response.data.message) {
                dispatch(failure(response.data.message.toString()));
                dispatch(alertActions.error(response.data.message.toString()));
            }
            else if (response.data.success) {
                dispatch(success(response.data));
                dispatch(alertActions.success(response.data.success.toString()));
            }
        }
        catch (error) {
            dispatch(failure(error.toString()));
            dispatch(alertActions.error(error.response ? error.response.data.message : error.message));
            throw error
        }
    };

    function request(payload) { return { type: userConstants.FORGOTPASSWORD_REQUEST, payload } }
    function success(payload) { return { type: userConstants.FORGOTPASSWORD_SUCCESS, payload } }
    function failure(error) { return { type: userConstants.FORGOTPASSWORD_FAILURE, error } }
}

function updateContactInfo(payload) {
    return async dispatch => {
        dispatch(request(payload));
        try {
            // dispatch(updateLoaderState(true));
            const response = await profileAPIs.updateUserDetails(payload);
            if (response.data.error) {
                dispatch(alertActions.error(response.data.error.toString()));
                // history.push('/profile?tab=5');
            }
            if (response.data.message) {
                dispatch(alertActions.error(response.data.message.toString()));
                // history.push('/profile?tab=5');
            }
            if (response.data.id) {
                UserService.saveUser(response.data)
                dispatch(alertActions.success("Information updated successfuly!"));
                // history.push('/profile?tab=5');
            }
            dispatch(updateLoaderState(false));
        }
        catch (error) {
            const errorMessage = error.response ? error.response.data.message : error.message
            dispatch(failure(errorMessage));
            dispatch(alertActions.error(errorMessage));
            dispatch(updateLoaderState(false));
        }
    };

    function request(payload) { return { type: userConstants.FORGOTPASSWORD_REQUEST, payload } }
    function success(payload) { return { type: userConstants.FORGOTPASSWORD_SUCCESS, payload } }
    function failure(error) { return { type: userConstants.FORGOTPASSWORD_FAILURE, error } }
}

function updateProfileImage(payload) {
    return async dispatch => {
        dispatch(request(payload));
        try {
            const response = await profileAPIs.updateProfileImage(payload, userConstants.IS_FILE_UPLOAD);
            if (response.data.error) {
                dispatch(failure(response.data.error.toString()));
                dispatch(alertActions.error(response.data.error.toString()));
                return false;
            }
            if (response.data.message) {
                dispatch(failure(response.data.message.toString()));
                dispatch(alertActions.error(response.data.message.toString()));
                return false;
            }
            if (response.data.success) {
                dispatch(success(response.data));
                dispatch(alertActions.success(response.data.success));
                // dispatch(profileActions.fetchUserData())
                return true;
            }
        }
        catch (error) {
            dispatch(failure('Something went wrong, Please try later'));
            dispatch(alertActions.error(error.response ? error.response.data.message : error.message));
            return false
        }
    };

    function request(payload) { return { type: userConstants.FORGOTPASSWORD_REQUEST, payload } }
    function success(payload) { return { type: userConstants.FORGOTPASSWORD_SUCCESS, payload } }
    function failure(error) { return { type: userConstants.FORGOTPASSWORD_FAILURE, error } }
}

function fetchUserData() {
    return async dispatch => {
        try {
            const response = await userAPIs.fetchUserDetails();
            if (response.data.error) {
                return false;
            }
            if (response.data) {
                UserService.saveUser(response.data.data)
                dispatch(exportUserData(response.data.data));
            }
        }
        catch {
            return false;
        }
    };
}

function getUserTotalDonation(user_id) {
    return async dispatch => {
        try {
            const response = await userAPIs.getUserTotalDonation(user_id)
            if (response.data.error) {
                return false;
            }
            if (response.data) {
                dispatch(exportUserStats(response.data.data));
            }
        }
        catch {
            return false
        }
    };
}

function getUserDonationHistory(payload) {
    return async dispatch => {
        try {
            const response = await userAPIs.getUserDonationHistory(payload)
            if (response.data.error) {
                return false;
            }
            if (response.data) {
                dispatch(exportDonationsPaginateByUser(response.data.data));
                // dispatch(exportDonationsByUser(response.data.data));
            }
        }
        catch (error) {
            return false;
        }
    };
}

function getLatestDonationsByUser(user_id, limit) {
    return async dispatch => {
        try {
            const response = await userAPIs.getUserRecentDonations(user_id, limit);
            if (response.data.error) {
                return false;
            }
            if (response.data) {
                dispatch(exportLatestDonationsByUser(response.data.data));
            }
        }
        catch (error) {
            return false
        }
    };
}

function cancelSubscription(payload) {
    return async dispatch => {
        try {
            let response;
            if (payload.payment_method === "stripe")
                response = await profileAPIs.stripeCancelSubscription(payload)
            else if (payload.payment_method === "paypal")
                response = await profileAPIs.paypalCancelSubscription(payload)

            dispatch(updateLoaderState(false));
            if (response.data.error) {
                dispatch(alertActions.error(response.data.error.toString()));
                return false
            }
            if (response.data.success) {
                dispatch(alertActions.success(response.data.success.toString()));
                dispatch(getUserDonationHistory(payload.user_id, 20, 1));
                window.location.href = '/profile?tab=4';
            }
        }
        catch (error) {
            const errorMessage = error.response ? error.response.data.message : error.message
            dispatch(alertActions.error(errorMessage));
            return false
        }
        // let apiEndpoint = "";
        // if (payload.payment_method === "stripe") {
        //     apiEndpoint = 'api/profile/stripe-cancel-subscription';
        // } else if (payload.payment_method === "paypal") {
        //     apiEndpoint = 'api/profile/paypal-cancel-subscription';
        // }
        // userService.post(apiEndpoint, payload)
        //     .then((response) => {
        //         dispatch(updateLoaderState(false));
        //         if (response.status === 200) {
        //             if (response.data.error) {
        //                 dispatch(alertActions.error(response.data.error.toString()));
        //                 return false
        //             }
        //             if (response.data.success) {
        //                 dispatch(alertActions.success(response.data.success.toString()));
        //                 dispatch(getUserDonationHistory(payload.user_id, 20, 1));
        //                 history.push('/profile?tab=4');
        //             }
        //         } else {
        //             dispatch(alertActions.error(response.toString()));
        //             return false
        //         }
        //     },
        //         error => {
        //             dispatch(alertActions.error(error.toString()));
        //             return false
        //         }
        //     )
    };
}

function getUserActivities(user_id) {
    return async dispatch => {
        dispatch(updateLoaderState(true));
        let payload = {
            user_id: user_id
        };
        try {
            const response = await userAPIs.getUserActivities(payload);
            if (response.data.error) {
                return false;
            }
            if (response.data) {
                dispatch(exportUserActivities(response.data.data));
            }
            dispatch(updateLoaderState(false));
        }
        catch (error) {
            dispatch(updateLoaderState(false));
            return false;
        }
    };
}

function getUserGraphData(user_id) {
    return async dispatch => {
        dispatch(updateLoaderState(true));
        let payload = {
            user_id: user_id
        };
        try {
            const response = await userAPIs.getUserGraphData(payload);
            if (response.data.error) {
                return false;
            }
            if (response.data) {
                dispatch(exportUserGraphData(response.data.data));
            }
            dispatch(updateLoaderState(false));
        }
        catch {
            dispatch(updateLoaderState(false));
            return false;
        }
    };
}

export function exportUserData(current_user) {
    return {
        type: 'CURRENT_USER',
        current_user: current_user
    }
}

export function exportUserStats(user_stats) {
    return {
        type: 'USER_STATS',
        user_stats: user_stats
    }
}

export function exportDonationsByUser(donations_by_user) {
    return {
        type: 'DONATIONS_BY_USER',
        donations_by_user: donations_by_user
    }
}

export function exportDonationsPaginateByUser(donations_paginate_by_user) {
    return {
        type: 'DONATIONS_PAGINATE_BY_USER',
        donations_paginate_by_user: donations_paginate_by_user
    }
}

export function exportLatestDonationsByUser(latest_donations_by_user) {
    return {
        type: 'LATEST_DONATIONS_BY_USER',
        latest_donations_by_user: latest_donations_by_user
    }
}

export function updateLoaderState(loader_state) {
    return {
        type: "UPDATE_LOADER_STATE",
        loader_state: loader_state
    }
}

export function updateLoaderStatePassword(loader_state_password) {
    return {
        type: "UPDATE_LOADER_STATE_PASSWORD",
        loader_state_password: loader_state_password
    }
}

export function exportUserActivities(user_activities) {
    return {
        type: "USER_ACTIVITIES",
        user_activities: user_activities
    }
}

export function exportUserGraphData(user_graph_data) {
    return {
        type: "USER_GRAPH_DATA",
        user_graph_data: user_graph_data
    }
}